<template>
    <div>
        <div class="pdv-shell">
            <!-- Catálogo de produtos -->
            <div class="pdv-catalog">
                <header class="pdv-panel-header">
                    <div class="pdv-panel-header__title">
                        <i class="bi bi-shop"></i>
                        <h1>{{ name_business }}</h1>
                    </div>
                    <div class="d-flex gap-2">
                        <router-link v-if="auth.canManageProduct" :to="{ name: 'estoque' }" class="btn btn-outline-light btn-sm" title="Entrada/descarte de estoque">
                            <i class="bi bi-box-seam-fill"></i>
                        </router-link>
                        <!-- "Todos devem ter a opção de orçamento" — o botão
                             aparece pra todo operador quando a loja liga o
                             módulo; só a emissão em si é recusada (403) pra
                             quem não tem can_manage_budget, ver salvarOrcamento(). -->
                        <button v-if="auth.servicesEnabled" type="button" @click="show_orcamentos()" class="btn btn-outline-light btn-sm" title="Ver orçamentos">
                            <i class="bi bi-list-check"></i>
                        </button>
                        <button v-if="auth.servicesEnabled" type="button" @click="show_orcamento()" class="btn btn-outline-light btn-sm" title="Emitir orçamento com os itens do carrinho">
                            <i class="bi bi-file-earmark-text-fill me-1"></i>Orçamento
                        </button>
                        <button type="button" @click="abrirConfigImpressao()" class="btn btn-outline-light btn-sm" title="Configurar impressão do recibo">
                            <i class="bi bi-printer"></i>
                        </button>
                        <button type="button" @click="show_fechar_caixa()" class="btn btn-outline-light btn-sm">
                            <i class="bi bi-box-arrow-right me-1"></i>Fechar caixa
                        </button>
                    </div>
                </header>

                <div class="pdv-search">
                    <div class="input-icon-group flex-grow-1">
                        <i class="bi bi-search"></i>
                        <input autocomplete="off" type="text" v-model="buscaprodutos" @input="filtrarSugestoesProdutos()" class="form-control" name="frm_pesquisa_produto" id="frm_pesquisa_produto" placeholder="Buscar produto por nome...">
                    </div>
                    <button type="button" @click="limparProduto()" class="btn btn-outline-danger" title="Limpar busca">
                        <i class="bi bi-x-lg"></i>
                    </button>
                </div>

                <div class="pdv-product-grid">
                    <!-- Grade de sugestões da busca -->
                    <template v-if="sugestoesprodutos.length">
                        <div class="product-tile" v-for="item in sugestoesprodutos" :key="item.type + '-' + item.id" @click="selecionarproduto(item)">
                            <div class="product-tile__name">{{ item.name }} <span v-if="item.type === 'service'" class="badge text-bg-light border">serviço</span></div>
                            <div class="product-tile__meta">
                                <span class="product-tile__code"><i class="bi bi-upc"></i> {{ item.code || '-' }}</span>
                                <span class="product-tile__price">R$ {{ item.price.toFixed(2) }}</span>
                            </div>
                        </div>
                    </template>
                    <!-- Grade com todos os produtos -->
                    <template v-if="!sugestoesprodutos.length">
                        <div class="product-tile" v-for="produto in lista_produtos" :key="produto.type + '-' + produto.id" @click="show_add_item(produto)">
                            <div class="product-tile__name">{{ produto.name }} <span v-if="produto.type === 'service'" class="badge text-bg-light border">serviço</span></div>
                            <div class="product-tile__meta">
                                <span class="product-tile__code"><i class="bi bi-upc"></i> {{ produto.code || '-' }}</span>
                                <span class="product-tile__price">R$ {{ produto.price.toFixed(2) }}</span>
                            </div>
                        </div>
                    </template>
                </div>
            </div>

            <!-- Carrinho -->
            <div class="pdv-cart">
                <header class="pdv-panel-header">
                    <div class="pdv-panel-header__title">
                        <i class="bi bi-cart3"></i>
                        <h1>Carrinho</h1>
                    </div>
                </header>

                <div class="pdv-cart-list">
                    <table class="table pdv-cart-table" v-if="dados.lista.length">
                        <thead>
                            <tr>
                                <th>Produto</th>
                                <th>Preço</th>
                                <th>Qtd</th>
                                <th>Total</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in dados.lista" :key="item.type + '-' + item.id" @dblclick="show_editar_item(item)">
                                <td>{{ item.name }} <span v-if="item.type === 'service'" class="badge text-bg-light border">serviço</span></td>
                                <td>R$ {{ item.price.toFixed(2) }}</td>
                                <td>{{ item.quant }} {{ item.measure }}</td>
                                <td>R$ {{ item.total.toFixed(2) }}</td>
                                <td class="text-end">
                                    <button type="button" @click="show_editar_item(item)" class="btn btn-light btn-sm" title="Editar item">
                                        <i class="bi bi-pencil"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-else class="pdv-cart-empty">
                        <i class="bi bi-cart-x"></i>
                        <p class="mb-0">Carrinho vazio</p>
                        <span>Toque em um produto para adicionar</span>
                    </div>
                </div>

                <div class="pdv-cart-total">
                    <span>Total</span>
                    <strong>R$ {{ dados.total.toFixed(2) }}</strong>
                </div>
                <div class="pdv-cart-actions">
                    <button type="button" @click="limpar_lista_compras()" class="btn btn-outline-secondary">
                        <i class="bi bi-x-circle me-1"></i>Cancelar
                    </button>
                    <button type="button" @click="show_finalizar" class="btn btn-success btn-lg">
                        <i class="bi bi-check-circle me-2"></i>Finalizar
                    </button>
                </div>
            </div>
        </div>

        <!-- Modal Quantidade de Itens -->
        <div class="modal fade" id="modal_quant_item" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><i class="bi bi-basket3 me-2"></i>Quantidade</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form id="form-produto" @submit.prevent="add_item(item)">
                        <div class="modal-body">
                            <label class="form-label fs-4 fw-semibold text">{{ item.name }}</label>
                            <div class="mb-3 col">
                                <label for="exampleFormControlInput1" class="form-label">Quantidade:</label>
                                <input value="0" v-model="item.quant" type="number" step="0.1" class="form-control form-control-lg text-center" id="exampleFormControlInput1">
                            </div>
                            <div>
                                <div v-if="item.measure == 'UN'">
                                    <div class="row g-2">
                                        <div class="col-3 d-grid">
                                            <button @click="addQuant(1)" type="button" class="btn btn-outline-primary quant-btn">+1</button>
                                        </div>
                                        <div class="col-3 d-grid">
                                            <button @click="addQuant(2)" type="button" class="btn btn-outline-primary quant-btn">+2</button>
                                        </div>
                                        <div class="col-3 d-grid">
                                            <button @click="addQuant(5)" type="button" class="btn btn-outline-primary quant-btn">+5</button>
                                        </div>
                                        <div class="col-3 d-grid">
                                            <button @click="addQuant(10)" type="button" class="btn btn-outline-primary quant-btn">+10</button>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="item.measure == 'LT' || item.measure == 'KG'">
                                    <div class="row g-2">
                                        <div class="col d-grid">
                                            <button @click="addQuant(0.1)" type="button" class="btn btn-outline-primary quant-btn">+0.1</button>
                                        </div>
                                        <div class="col d-grid">
                                            <button @click="addQuant(0.5)" type="button" class="btn btn-outline-primary quant-btn">+0.5</button>
                                        </div>
                                        <div class="col d-grid">
                                            <button @click="addQuant(1)" type="button" class="btn btn-outline-primary quant-btn">+1</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                            <button type="submit" class="btn btn-success"><i class="bi bi-check-lg me-1"></i>Salvar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- Modal Editar Itens -->
        <div class="modal fade" id="modal_editar_item" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><i class="bi bi-pencil-square me-2"></i>Editar item</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form id="form-produto" @submit.prevent="edit_item(item)">
                        <div class="modal-body">
                            <label class="form-label fs-4 fw-semibold text">{{ item.name }}</label>
                            <div class="mb-3 col">
                                <label for="exampleFormControlInput1" class="form-label">Quantidade:</label>
                                <input v-model="item.quant" type="number" step="0.1" class="form-control form-control-lg text-center" id="exampleFormControlInput1">
                            </div>
                            <div>
                                <div v-if="item.measure == 'UN'">
                                    <div class="row g-2">
                                        <div class="col-3 d-grid">
                                            <button @click="addQuant(-1)" type="button" class="btn btn-outline-warning quant-btn">-1</button>
                                        </div>
                                        <div class="col-3 d-grid">
                                            <button @click="addQuant(-2)" type="button" class="btn btn-outline-warning quant-btn">-2</button>
                                        </div>
                                        <div class="col-3 d-grid">
                                            <button @click="addQuant(1)" type="button" class="btn btn-outline-primary quant-btn">+1</button>
                                        </div>
                                        <div class="col-3 d-grid">
                                            <button @click="addQuant(2)" type="button" class="btn btn-outline-primary quant-btn">+2</button>
                                        </div>
                                    </div>
                                    <div class="row g-2 mt-1">
                                        <div class="col d-grid">
                                            <button type="button" @click="remove_item(item)" class="btn btn-outline-danger">
                                                <i class="bi bi-trash3 me-1"></i>Remover item
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="item.measure == 'LT' || item.measure == 'KG'">
                                    <div class="row g-2">
                                        <div class="col d-grid">
                                            <button @click="addQuant(-0.1)" type="button" class="btn btn-outline-warning quant-btn">-0.1</button>
                                        </div>
                                        <div class="col d-grid">
                                            <button @click="addQuant(-0.5)" type="button" class="btn btn-outline-warning quant-btn">-0.5</button>
                                        </div>
                                        <div class="col d-grid">
                                            <button @click="addQuant(0.1)" type="button" class="btn btn-outline-primary quant-btn">+0.1</button>
                                        </div>
                                        <div class="col d-grid">
                                            <button @click="addQuant(0.5)" type="button" class="btn btn-outline-primary quant-btn">+0.5</button>
                                        </div>
                                    </div>
                                    <div class="row g-2 mt-1">
                                        <div class="col d-grid">
                                            <button type="button" @click="remove_item(item)" class="btn btn-outline-danger">
                                                <i class="bi bi-trash3 me-1"></i>Remover item
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                            <button type="submit" class="btn btn-success"><i class="bi bi-check-lg me-1"></i>Salvar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- Modal Finalizar Venda -->
        <div class="modal fade" id="modal_finalizar" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><i class="bi bi-check-circle me-2"></i>{{ convertendoOrcamentoId ? 'Converter orçamento em venda' : 'Finalizar venda' }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form @submit.prevent id="form-produto">
                        <div class="modal-body">
                            <div class="pdv-total-highlight">R$ {{ dados.total.toFixed(2) }}</div>
                            <div class="mb-3 col" v-if="!convertendoOrcamentoId">
                                <label for="frm_pesquisa_cliente" class="form-label">Cliente:</label>
                                <div class="mb-2">
                                    <div class="row g-2">
                                        <div class="col-10">
                                            <div class="input-icon-group">
                                                <i class="bi bi-person"></i>
                                                <input autocomplete="off" type="text" v-model="buscacliente" @input="filtrarSugestoes" class="form-control" name="frm_pesquisa_cliente" id="frm_pesquisa_cliente" placeholder="Pesquisar cliente">
                                            </div>
                                        </div>
                                        <div class="col-2 d-grid">
                                            <button @click="limparCliente()" type="button" class="btn btn-outline-danger"><i class="bi bi-x-lg"></i></button>
                                        </div>
                                    </div>
                                    <div class="pdv-suggestions" v-if="sugestoes.length">
                                        <div class="pdv-suggestions__item" v-for="(item, index) in sugestoes" :key="item.id" @click="selecionar(item)">
                                            {{ item.name }}
                                        </div>
                                    </div>
                                    <button v-if="auth.canManageCustomer" @click="abrirNovoCliente()" type="button" class="btn btn-sm btn-outline-primary mt-2">
                                        <i class="bi bi-person-plus me-1"></i>Novo cliente
                                    </button>
                                </div>
                                <span class="text-muted">Cliente selecionado: <b class="text-dark">{{ dados.cliete?.name ?? 'Avulso' }}</b></span>
                            </div>
                            <!-- Convertendo orçamento: cliente já vem definido de lá (o
                                 backend usa o do orçamento, não o que estiver aqui) —
                                 só mostra, não deixa trocar. -->
                            <div class="mb-3 col" v-else>
                                <label class="form-label">Cliente:</label>
                                <div><b class="text-dark">{{ dados.cliete === 'avulso' ? 'Avulso' : dados.cliete.name }}</b></div>
                                <span class="text-muted small">Definido pelo orçamento — não pode ser alterado aqui.</span>
                            </div>
                            <label class="form-label">Forma de pagamento:</label>
                            <div class="mb-3 col pdv-payment-methods">
                                <template v-for="metodo in lista_metodos_pagamento" :key="metodo.id">
                                    <div v-if="metodo.type !== 'onaccount' || (dados.cliete != 'avulso' && dados.cliete.onaccount != 'not')" class="form-check form-check-inline">
                                        <input :value="metodo.id" v-model="dados.payment_method_id" type="radio" class="btn-check" name="pagamento-finalizar" :id="'radio-finalizar-' + metodo.id">
                                        <label class="btn btn-outline-success" :for="'radio-finalizar-' + metodo.id"><i class="bi me-1" :class="iconeMetodo(metodo.type)"></i>{{ metodo.name }}</label>
                                    </div>
                                </template>
                            </div>
                            <div v-show="dados.pagamento == 'cash'" class="pdv-troco">
                                <label class="form-label">Calcular troco:</label>
                                <div class="mb-2 col">
                                    <input autocomplete="off" @input="calcularTroco()" v-model="trocovalueCliente" type="number" class="form-control" name="frm_pesquisa_cliente" id="frm_pesquisa_cliente" placeholder="O cliente entregou R$ ..">
                                </div>
                                <span>Troco de: <b>R$ {{ trocovalue }}</b></span>
                            </div>
                        </div>
                    </form>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                        <button @click="finalizarOuConverter()" class="btn btn-primary">
                            <i class="bi bi-check-lg me-1"></i>{{ convertendoOrcamentoId ? 'Converter em venda' : 'Finalizar' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Novo cliente -->
        <div class="modal fade" id="modal_novo_cliente" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><i class="bi bi-person-plus me-2"></i>Novo cliente</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form @submit.prevent="salvarNovoCliente()">
                        <div class="modal-body">
                            <div class="mb-3">
                                <label for="inp_novo_cliente_nome" class="form-label">Nome:</label>
                                <input v-model="novoCliente.name" required type="text" autocomplete="off" class="form-control" id="inp_novo_cliente_nome">
                            </div>
                            <div class="mb-3">
                                <label for="inp_novo_cliente_telefone" class="form-label">Telefone:</label>
                                <input v-model="novoCliente.phone" type="text" autocomplete="off" class="form-control" id="inp_novo_cliente_telefone">
                            </div>
                            <div class="form-check" v-if="auth.canManageOnaccount">
                                <input v-model="novoCliente.createaccount" class="form-check-input" type="checkbox" id="inp_novo_cliente_fiado">
                                <label class="form-check-label" for="inp_novo_cliente_fiado">Já criar conta fiado (crediário) para este cliente</label>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                            <button type="submit" class="btn btn-primary" :disabled="salvandoCliente">
                                {{ salvandoCliente ? 'Salvando...' : 'Salvar' }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- Modal Orçamento (emitir com os itens do carrinho atual) -->
        <div class="modal fade" id="modal_orcamento" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><i class="bi bi-file-earmark-text-fill me-2"></i>Emitir orçamento</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p v-if="!dados.lista.length" class="text-muted mb-0">
                            Adicione produtos/serviços ao carrinho antes de emitir o orçamento.
                        </p>
                        <template v-else>
                            <div class="pdv-total-highlight mb-3">R$ {{ dados.total.toFixed(2) }}</div>
                            <ul class="list-unstyled small mb-3">
                                <li v-for="item in dados.lista" :key="item.type + '-' + item.id">
                                    {{ item.quant }}x {{ item.name }} <span v-if="item.type === 'service'" class="badge text-bg-light border">serviço</span>
                                    — R$ {{ item.total.toFixed(2) }}
                                </li>
                            </ul>
                            <div class="mb-3 col">
                                <label class="form-label">Cliente:</label>
                                <div class="row g-2">
                                    <div class="col-10">
                                        <div class="input-icon-group">
                                            <i class="bi bi-person"></i>
                                            <input autocomplete="off" type="text" v-model="buscacliente" @input="filtrarSugestoes" class="form-control" placeholder="Pesquisar cliente">
                                        </div>
                                    </div>
                                    <div class="col-2 d-grid">
                                        <button @click="limparCliente()" type="button" class="btn btn-outline-danger"><i class="bi bi-x-lg"></i></button>
                                    </div>
                                </div>
                                <div class="pdv-suggestions" v-if="sugestoes.length">
                                    <div class="pdv-suggestions__item" v-for="item in sugestoes" :key="item.id" @click="selecionar(item)">
                                        {{ item.name }}
                                    </div>
                                </div>
                                <span class="text-muted small">Selecionado: <b class="text-dark">{{ dados.cliete?.name ?? 'Avulso' }}</b></span>
                            </div>
                            <div class="mb-3">
                                <label for="inp_orcamento_desc" class="form-label">Observações (opcional):</label>
                                <textarea v-model="orcamentoDescricao" class="form-control" id="inp_orcamento_desc" rows="2"></textarea>
                            </div>
                            <!-- Agendar visita é opcional e só faz sentido quando o
                                 carrinho tem algum serviço (agendamento sempre precisa
                                 de um serviço, ver AppointmentController). -->
                            <div class="mb-1" v-if="servicosNoCarrinho.length">
                                <div class="form-check form-switch">
                                    <input v-model="agendarVisita" @change="toggleAgendarVisita" class="form-check-input" type="checkbox" role="switch" id="inp_agendar_visita">
                                    <label class="form-check-label" for="inp_agendar_visita">Agendar visita para este orçamento</label>
                                </div>
                                <div v-if="agendarVisita" class="row g-2 mt-1">
                                    <div class="col-12" v-if="servicosNoCarrinho.length > 1">
                                        <label class="form-label small">Serviço:</label>
                                        <select v-model="agendamentoServicoId" @change="atualizarDuracaoAgendamento" class="form-select form-select-sm">
                                            <option v-for="s in servicosNoCarrinho" :key="s.id" :value="s.id">{{ s.name }}</option>
                                        </select>
                                    </div>
                                    <div class="col">
                                        <label class="form-label small">Data e hora:</label>
                                        <input v-model="agendamentoData" type="datetime-local" class="form-control form-control-sm">
                                    </div>
                                    <div class="col">
                                        <label class="form-label small">Duração (min):</label>
                                        <input v-model="agendamentoDuracao" type="number" min="1" class="form-control form-control-sm">
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                        <button type="button" @click="salvarOrcamento()" class="btn btn-primary" :disabled="!dados.lista.length || salvandoOrcamento">
                            {{ salvandoOrcamento ? 'Emitindo...' : 'Emitir orçamento' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Ver orçamentos -->
        <div class="modal fade" id="modal_orcamentos" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><i class="bi bi-list-check me-2"></i>Orçamentos</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <!-- Aparece só logo depois de emitir um novo orçamento
                             (ver salvarOrcamento) — a linha dele fica destacada
                             na tabela abaixo. -->
                        <div v-if="orcamentoEmitidoId" class="alert alert-success d-flex align-items-start gap-2">
                            <i class="bi bi-check-circle-fill mt-1"></i>
                            <span>
                                Orçamento #{{ orcamentoEmitidoId }} emitido com sucesso — confira os detalhes na linha destacada abaixo e, se quiser, imprima pra entregar ao cliente.
                                <template v-if="orcamentoAgendamentoInfo?.ok"> Visita agendada para {{ formatarDataRecibo(orcamentoAgendamentoInfo.when) }}.</template>
                            </span>
                        </div>
                        <div v-if="orcamentoAgendamentoInfo && !orcamentoAgendamentoInfo.ok" class="alert alert-warning">
                            {{ orcamentoAgendamentoInfo.message }}
                        </div>
                        <p class="text-muted small">Seus orçamentos emitidos nos últimos 7 dias.</p>
                        <table class="table table-sm" v-if="lista_orcamentos.length">
                            <thead>
                                <tr><th>Emitido em</th><th>Cliente</th><th>Itens</th><th>Total</th><th>Status</th><th></th></tr>
                            </thead>
                            <tbody>
                                <tr v-for="orc in lista_orcamentos" :key="orc.id" :class="{ 'table-success': orc.id === orcamentoEmitidoId }">
                                    <td>{{ formatarDataRecibo(orc.created_at) }}</td>
                                    <td>{{ orc.customer?.name ?? 'Avulso' }}</td>
                                    <td>
                                        {{ (orc.products?.length ?? 0) + (orc.services?.length ?? 0) }}
                                        <i v-if="orc.appointment" class="bi bi-calendar-check text-primary ms-1" :title="'Visita agendada para ' + formatarDataRecibo(orc.appointment.scheduled_at)"></i>
                                    </td>
                                    <td>R$ {{ Number(orc.total).toFixed(2) }}</td>
                                    <td>
                                        <span class="badge" :class="orcamentoStatusBadge(orc.status)">{{ orcamentoStatusLabel(orc.status) }}</span>
                                    </td>
                                    <td class="text-end">
                                        <button type="button" class="btn btn-outline-secondary btn-sm me-1" title="Imprimir orçamento" @click="imprimirOrcamento(orc)">
                                            <i class="bi bi-printer"></i>
                                        </button>
                                        <button
                                            v-if="orc.status === 'approved' && !orc.operation_id"
                                            type="button" class="btn btn-success btn-sm"
                                            @click="abrirConversaoOrcamento(orc)"
                                        >
                                            Converter em venda
                                        </button>
                                        <span v-else-if="orc.operation_id" class="text-success small"><i class="bi bi-check-circle-fill me-1"></i>Já virou venda</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p v-else class="text-muted mb-0">Nenhum orçamento emitido nos últimos 7 dias.</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Pagamento de conta -->
        <div class="modal fade" id="modal_pagamentoconta" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><i class="bi bi-credit-card-2-front me-2"></i>Registrar pagamento</h5>
                        <button type="button" @click="limparClientePagConta()" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form @submit.prevent id="form-produto">
                        <div class="modal-body">
                            <div class="mb-3 col">
                                <label for="frm_pesquisa_cliente" class="form-label">Cliente:</label>
                                <div class="mb-2">
                                    <div class="row g-2">
                                        <div class="col-10">
                                            <div class="input-icon-group">
                                                <i class="bi bi-person"></i>
                                                <input autocomplete="off" type="text" v-model="buscaclientePagConta" @input="filtrarSugestoesPagConta" class="form-control" name="frm_pesquisa_cliente" id="frm_pesquisa_cliente" placeholder="Pesquisar cliente">
                                            </div>
                                        </div>
                                        <div class="col-2 d-grid">
                                            <button @click="limparClientePagConta()" type="button" class="btn btn-outline-danger"><i class="bi bi-x-lg"></i></button>
                                        </div>
                                    </div>
                                    <div class="pdv-suggestions" v-if="sugestoesPagConta.length">
                                        <div class="pdv-suggestions__item" v-for="(item, index) in sugestoesPagConta" :key="item.id" @click="selecionarPagConta(item)">
                                            {{ item.name }}
                                        </div>
                                    </div>
                                </div>
                                <span class="form-label">Valor em aberto: <b class="text-danger">R$ {{ onaccontvalue ?? 0 }}</b></span>
                            </div>
                            <div class="mb-3 col">
                                <label for="frm_pesquisa_cliente" class="form-label">Valor do pagamento:</label>
                                <div class="mb-2">
                                    <div class="row">
                                        <div class="col">
                                            <div class="input-icon-group">
                                                <i class="bi bi-cash-coin"></i>
                                                <input autocomplete="off" type="text" v-model="dados.valuepayment" class="form-control" name="frm_pesquisa_cliente" id="frm_pesquisa_cliente" placeholder="R$ ...">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <label class="form-label">Forma de pagamento:</label>
                            <div class="mb-3 col pdv-payment-methods">
                                <template v-for="metodo in lista_metodos_pagamento" :key="metodo.id">
                                    <div v-if="metodo.type !== 'onaccount'" class="form-check form-check-inline">
                                        <input :value="metodo.id" v-model="dados.payment_method_id" type="radio" class="btn-check" name="pagamento-pagconta" :id="'radio-pagconta-' + metodo.id">
                                        <label class="btn btn-outline-success" :for="'radio-pagconta-' + metodo.id"><i class="bi me-1" :class="iconeMetodo(metodo.type)"></i>{{ metodo.name }}</label>
                                    </div>
                                </template>
                            </div>
                            <div class="mb-3">
                                <label for="frm_description" class="form-label">Observação:</label>
                                <div class="row">
                                    <div class="col">
                                        <input autocomplete="off" type="text" v-model="dados.description" class="form-control" name="frm_description" id="frm_description" placeholder="...">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="modal-footer">
                        <button @click="enviarpagamento()" class="btn btn-primary"><i class="bi bi-check-lg me-1"></i>Finalizar</button>
                        <button type="button" @click="limparClientePagConta()" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Feedback -->
        <div class="modal fade" id="modal_feedback" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title"><i class="bi bi-check-circle-fill text-success me-2"></i>Sucesso</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                <p class="mb-0">{{ msn_feedback }}</p>
                </div>
                <div class="modal-footer" v-if="reciboVenda">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                    <button type="button" @click="imprimirRecibo()" class="btn btn-primary">
                        <i class="bi bi-printer me-1"></i>Imprimir recibo
                    </button>
                </div>
            </div>
            </div>
        </div>
        <!-- Modal Fechar Caixa -->
        <div class="modal fade" id="modal_fechar_caixa" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><i class="bi bi-door-closed me-2"></i>Fechar caixa</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form id="form-produto">
                        <div class="modal-body">
                            <div class="mb-3 col">
                                <label for="exampleFormControlInput1" class="form-label">Valor final:</label>
                                <div class="input-icon-group">
                                    <i class="bi bi-cash-coin"></i>
                                    <input v-model="caixa_dados.final" type="number" step="0.1" class="form-control" id="exampleFormControlInput1">
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                            <button type="button" @click="enviar_fechamento()" class="btn btn-success"><i class="bi bi-box-arrow-right me-1"></i>Fechar Caixa</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- Modal Autorização -->
        <div class="modal fade" id="modal_autorizacao" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><i class="bi bi-shield-lock me-2"></i>Autorização</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form id="form-produto">
                        <div class="modal-body">
                            <div class="mb-3 col">
                                <label for="exampleFormControlInput1" class="form-label">Senha do gerente:</label>
                                <div class="input-icon-group">
                                    <i class="bi bi-lock"></i>
                                    <input required type="password" class="form-control" id="exampleFormControlInput1">
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                            <button type="button" @click="enviar_gerente_pass()" class="btn btn-success"><i class="bi bi-check-lg me-1"></i>Enviar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- Modal Configuração de impressão (recibo térmico) -->
        <div class="modal fade" id="modal_config_impressao" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><i class="bi bi-printer me-2"></i>Configurar impressão</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p class="text-muted small">
                            Ajuste conforme a impressora térmica conectada neste computador. Vale só para este terminal.
                        </p>
                        <div class="mb-3">
                            <label for="inp_config_largura" class="form-label">Largura do papel (mm):</label>
                            <select v-model.number="printForm.width" class="form-select" id="inp_config_largura">
                                <option :value="58">58mm</option>
                                <option :value="80">80mm</option>
                            </select>
                        </div>
                        <div class="mb-3">
                            <label for="inp_config_fonte" class="form-label">Tamanho da letra (px):</label>
                            <input v-model.number="printForm.fontSize" type="number" min="8" max="24" step="1" class="form-control" id="inp_config_fonte">
                        </div>
                        <div class="mb-3">
                            <label for="inp_config_margem" class="form-label">Margem (mm):</label>
                            <input v-model.number="printForm.margin" type="number" min="0" max="20" step="1" class="form-control" id="inp_config_margem">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                        <button type="button" @click="salvarConfigImpressao()" class="btn btn-primary"><i class="bi bi-check-lg me-1"></i>Salvar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Recibo (não fiscal) para impressão térmica: fica escondido na
             tela e só aparece no diálogo de impressão do navegador
             (ver bloco @media print no <style> não-escopado abaixo). As
             variáveis --recibo-* vêm da configuração de impressão do
             terminal (ver printSettings.js) e são lidas nesse bloco. -->
        <div id="recibo-impressao" v-if="reciboVenda" :style="reciboImpressaoStyle">
            <div class="recibo">
                <div class="recibo__center">
                    <strong>{{ reciboVenda.business || 'LC3 Market' }}</strong>
                    <div>Cupom não fiscal</div>
                </div>
                <div class="recibo__linha-tracejada"></div>
                <div>Venda #{{ reciboVenda.id }}</div>
                <div>{{ formatarDataRecibo(reciboVenda.date) }}</div>
                <div>Operador: {{ reciboVenda.operator }}</div>
                <div v-if="reciboVenda.cliente">Cliente: {{ reciboVenda.cliente }}</div>
                <div class="recibo__linha-tracejada"></div>
                <div class="recibo__item" v-for="(item, index) in reciboVenda.itens" :key="index">
                    <div>{{ item.name }}</div>
                    <div class="recibo__linha">
                        <span>{{ item.quant }} {{ item.measure }} x R$ {{ Number(item.price).toFixed(2) }}</span>
                        <span>R$ {{ Number(item.total).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="recibo__linha-tracejada"></div>
                <div class="recibo__linha recibo__total">
                    <span>TOTAL</span>
                    <span>R$ {{ Number(reciboVenda.total).toFixed(2) }}</span>
                </div>
                <div class="recibo__linha">
                    <span>Pagamento</span>
                    <span>{{ reciboVenda.pagamentoNome }}</span>
                </div>
                <div class="recibo__linha" v-if="reciboVenda.troco != null">
                    <span>Troco</span>
                    <span>R$ {{ Number(reciboVenda.troco).toFixed(2) }}</span>
                </div>
                <div class="recibo__linha-tracejada"></div>
                <div class="recibo__center recibo__rodape">Este documento não possui valor fiscal.</div>
            </div>
        </div>

        <!-- Recibo de orçamento pra impressão — mesmo mecanismo do recibo de
             venda acima (ver bloco @media print no <style> não-escopado). -->
        <div id="orcamento-impressao" v-if="reciboOrcamento" :style="reciboImpressaoStyle">
            <div class="recibo">
                <div class="recibo__center">
                    <strong>{{ reciboOrcamento.business || 'LC3 Market' }}</strong>
                    <div>Orçamento</div>
                </div>
                <div class="recibo__linha-tracejada"></div>
                <div>Orçamento #{{ reciboOrcamento.id }}</div>
                <div>{{ formatarDataRecibo(reciboOrcamento.date) }}</div>
                <div>Emitido por: {{ reciboOrcamento.operator }}</div>
                <div v-if="reciboOrcamento.cliente">Cliente: {{ reciboOrcamento.cliente }}</div>
                <div>Status: {{ reciboOrcamento.status }}</div>
                <div v-if="reciboOrcamento.validoAte">Válido até: {{ formatarDataRecibo(reciboOrcamento.validoAte) }}</div>
                <div class="recibo__linha-tracejada"></div>
                <div class="recibo__item" v-for="(item, index) in reciboOrcamento.itens" :key="index">
                    <div>{{ item.name }}<span v-if="item.servico"> (serviço)</span></div>
                    <div class="recibo__linha">
                        <span>{{ item.quant }} x R$ {{ Number(item.price).toFixed(2) }}</span>
                        <span>R$ {{ Number(item.total).toFixed(2) }}</span>
                    </div>
                </div>
                <div class="recibo__linha-tracejada"></div>
                <div class="recibo__linha recibo__total">
                    <span>TOTAL</span>
                    <span>R$ {{ Number(reciboOrcamento.total).toFixed(2) }}</span>
                </div>
                <div v-if="reciboOrcamento.descricao" class="recibo__linha-tracejada"></div>
                <div v-if="reciboOrcamento.descricao">Obs: {{ reciboOrcamento.descricao }}</div>
                <div class="recibo__linha-tracejada"></div>
                <div class="recibo__center recibo__rodape">Este documento é um orçamento e não representa uma venda concluída.</div>
            </div>
        </div>
    </div>
</template>

<script>
import { products } from '@/models/products';
import { services } from '@/models/services';
import { orcamentos } from '@/models/orcamentos';
import { agendamentos } from '@/models/agendamentos';
import { clientes } from '@/models/clientes';
import { vendas } from '@/models/vendas';
import { paymentMethods } from '@/models/paymentMethods';
import { infos } from '@/services/infos';
import { cashier } from '@/models/cashier';
import { printSettings } from '@/services/printSettings';
import { onMounted, ref, reactive, watch, onBeforeUnmount, nextTick, computed } from 'vue';
import { Modal } from "bootstrap";
import router from '@/router';
import { useAuth } from '@/services/auth.js';

export default {
    name: "PdvView",
    setup(){

        const Infos = infos();
        const name_business = Infos.business;
        const Produtos = products();
        const Servicos = services();
        const Orcamentos = orcamentos();
        const Agendamentos = agendamentos();
        const Clientes = clientes();
        const Vendas = vendas();
        const PaymentMethods = paymentMethods();
        const Cashier = cashier();
        const PrintSettings = printSettings();
        const lista_produtos = ref([]);
        const lista_clientes = ref([]);
        const lista_metodos_pagamento = ref([]);
        const buscacliente = ref([]);
        const buscaclientePagConta = ref([]);
        const buscaprodutos = ref([]);
        const auth = useAuth();
        const sugestoes = ref([]);
        const sugestoesPagConta = ref([]);
        const sugestoesprodutos = ref([]);
        const onaccontvalue = ref([]);
        const trocovalue = ref(0);
        const trocovalueCliente = ref(0);

        let modal = '';
        let zeros = 0;
        const msn_feedback = ref('');
        // Snapshot da última venda finalizada, usado só para montar o
        // recibo de impressão (nulo enquanto não há venda pra imprimir).
        const reciboVenda = ref(null);
        // Mesma ideia, pro orçamento que está sendo impresso no momento
        // (ver imprimirOrcamento) — nunca os dois preenchidos ao mesmo
        // tempo, senão os dois blocos escondidos apareceriam juntos na
        // impressão.
        const reciboOrcamento = ref(null);

        // Rascunho editado no modal de configuração de impressão — só grava
        // em PrintSettings (e localStorage) quando o operador confirma, pra
        // não já ir aplicando no recibo a cada tecla digitada.
        const printForm = reactive({ width: PrintSettings.width, fontSize: PrintSettings.fontSize, margin: PrintSettings.margin });

        // Variáveis CSS lidas pelo bloco @media print (ver <style> não-
        // escopado no fim do arquivo) — aplicadas nos dois recibos porque a
        // configuração é da impressora do terminal, não da venda/orçamento.
        const reciboImpressaoStyle = computed(() => ({
            '--recibo-largura': PrintSettings.width + 'mm',
            '--recibo-fonte': PrintSettings.fontSize + 'px',
            '--recibo-margem': PrintSettings.margin + 'mm',
        }));

        const caixa_dados = reactive({
            final: 0
        })

        const novoCliente = reactive({ name: '', phone: '', createaccount: false });
        const salvandoCliente = ref(false);

        const dados = reactive({
            total: 0,
            lista: [],
            cliete: 'avulso',
            pagamento: 'cash',
            payment_method_id: null,
            valuepayment: 0,
            description: ''
        });

        // Mantém `dados.pagamento` (o tipo: cash/pix/card/onaccount) em sincronia
        // com a forma de pagamento escolhida, para não mexer na lógica que já
        // depende dele (troco só aparece pra tipo "cash", por exemplo).
        watch(() => dados.payment_method_id, (id) => {
            const metodo = lista_metodos_pagamento.value.find(m => m.id === id);
            if (metodo) {
                dados.pagamento = metodo.type;
            }
        });

        function iconeMetodo(type) {
            switch (type) {
                case 'cash': return 'bi-cash-coin';
                case 'pix': return 'bi-qr-code';
                case 'card': return 'bi-credit-card';
                case 'onaccount': return 'bi-wallet2';
                default: return 'bi-credit-card-2-front';
            }
        }

        function selecionarMetodoPadrao() {
            const padrao = lista_metodos_pagamento.value.find(m => m.type === 'cash') ?? lista_metodos_pagamento.value[0];
            dados.payment_method_id = padrao?.id ?? null;
        }

        // Sessão do leitor de codigos
        const buffer = ref('');
        let timeout = null;

        function handleKeypress(e) {
            if (timeout) clearTimeout(timeout);
            buffer.value += e.key;
            timeout = setTimeout(() => {
                if (buffer.value.length >= 10) {
                    processa_leitor(buffer.value.slice(0, -5));
                }
                buffer.value = '';
            }, 50);
        }

        //Teclas de Atalhos
        function handleKeydown(e) {
            switch (e.key) {

                //Finalizar Venda
                case "F4":
                    e.preventDefault();
                    show_finalizar();
                    break;

                //Lançar pagamento de conta
                case "F9":
                    e.preventDefault();
                    show_pagamentodeconta()
                    break;
            }

        }
        //-----------

        // Elemento de Autocoplete para cientes
        function filtrarSugestoes() {
            if (buscacliente.value.length === 0) {
                sugestoes.value = [];
                return;
            }

            sugestoes.value = lista_clientes.value.filter(item =>
                item.name.toLowerCase().includes(buscacliente.value.toLowerCase())
            );
        }

        function filtrarSugestoesPagConta() {
            if (buscaclientePagConta.value.length === 0) {
                sugestoesPagConta.value = [];
                return;
            }

            sugestoesPagConta.value = lista_clientes.value.filter(item =>
                item.name.toLowerCase().includes(buscaclientePagConta.value.toLowerCase())
            );
        }

        function selecionar(item) {
            dados.cliete = item;
            buscacliente.value = item.name;
            sugestoes.value = [];
        }

        function selecionarPagConta(item) {
            dados.cliete = item;
            buscaclientePagConta.value = item.name;
            getAccontValue(item.id);
            sugestoesPagConta.value = [];
        }

        function limparCliente() {
            buscacliente.value = [];
            dados.cliete = 'avulso';
        }

        function limparClientePagConta() {
            limparCliente()
            onaccontvalue.value = 0;
            buscaclientePagConta.value = [];
        }

        const getAccontValue = async (id) => {
            onaccontvalue.value = await Clientes.getAccontValue(id);
        }

        function abrirNovoCliente() {
            novoCliente.name = '';
            novoCliente.phone = '';
            novoCliente.createaccount = false;
            openModal('modal_novo_cliente');
        }

        async function salvarNovoCliente() {
            salvandoCliente.value = true;
            const criado = await Clientes.create(novoCliente);
            salvandoCliente.value = false;

            if (!criado) {
                msn_feedback.value = Clientes.lastErrorMessage.value || 'Erro ao cadastrar cliente!';
                openModal('modal_feedback');
                return;
            }

            lista_clientes.value.push(criado);
            closeModal();
            // Já deixa selecionado pra venda que estava sendo montada.
            selecionar(criado);
        }

        // -----
        // Função de buscar produto

        function limparProduto() {
            buscaprodutos.value = '';
            sugestoesprodutos.value = [];
        }

        function filtrarSugestoesProdutos() {
            if (buscaprodutos.value.length === 0) {
                sugestoesprodutos.value = [];
                return;
            }

            sugestoesprodutos.value = lista_produtos.value.filter(item =>
                item.name.toLowerCase().includes(buscaprodutos.value.toLowerCase())
            );
        }

        function selecionarproduto(item) {
            show_add_item(item)
            limparProduto()
        }

        // ------
        //Função Editar item

        function show_editar_item(item) {
            setItemEdit(item);

            if (!auth.edit) {
                openModal('modal_autorizacao');
            } else {
                openModal('modal_editar_item');
            }
        }

        function enviar_gerente_pass() {
            closeModal();
            openModal('modal_editar_item');
        }

        function edit_item(item) {
            const tipo = item.type ?? 'product';
            const existingItem = dados.lista.find(product => product.id === item.id && (product.type ?? 'product') === tipo);
            if (existingItem) {
                if (item.quant <= 0) {
                    remove_item(item);
                } else {
                    existingItem.quant = (Number(item.quant)).toFixed(zeros);
                    existingItem.total = (existingItem.quant * existingItem.price);
                }
            }
            closeModal();
            limparItem();
            calc_value();
        }

        function remove_item(item) {
            const tipo = item.type ?? 'product';
            const index = dados.lista.findIndex(product => product.id === item.id && (product.type ?? 'product') === tipo);
            if (index !== -1) {
                dados.lista.splice(index, 1);
            }
            closeModal();
            limparItem();
            calc_value();
        }

        //------
        //- Função de troco

        function calcularTroco() {
            trocovalue.value = trocovalueCliente.value - dados.total;
        }

        //-----
        const item = reactive({
            'id' : '',
            'type' : 'product',
            'name' : '',
            'code' : '',
            'price' : '',
            'measure' : '',
            'quant' : 0,
        })

        function limparItem() {
            item.id = '',
            item.type = 'product',
            item.name = '',
            item.price = '',
            item.code = '',
            item.measure = '',
            item.quant = 0
        }

        function processa_leitor(codigo) {
            const produto_encontrado = lista_produtos.value.find(product => product.code === codigo);
            if (produto_encontrado) {
                produto_encontrado.quant = 1;
                add_item(produto_encontrado);
            }
        }

        function setItem(prod) {
            item.id = prod.id,
            item.type = prod.type ?? 'product',
            item.name = prod.name,
            item.buy = prod.buy,
            item.price = prod.price,
            item.code = prod.code,
            item.measure = prod.measure,
            item.quant = 0
        }

        function setItemEdit(prod) {
            item.id = prod.id,
            item.type = prod.type ?? 'product',
            item.name = prod.name,
            item.price = prod.price,
            item.code = prod.code,
            item.measure = prod.measure,
            item.quant = prod.quant
        }

        function openModal(elemento) {
            const modalNovoProduto = document.getElementById(elemento);
            modal = new Modal(modalNovoProduto);
            modal.show();
        }

        function closeModal() {
            if (modal) {
                modal.hide();
            }
        }

        // Produto e serviço entram na mesma busca/grade (com uma etiqueta
        // "serviço" no item) — GET /pdv/services já volta lista vazia
        // quando o módulo está desligado, então dá pra chamar sempre sem
        // checagem extra aqui.
        const listProducts = async () => {
            const produtos = (await Produtos.list() ?? []).map(p => ({ ...p, type: 'product' }));
            // Serviço não tem `measure` (não é medido em KG/LT nem tem
            // estoque) — mas se vende "1 serviço", "2 serviços" etc., então
            // conta como 'UN' pros botões de atalho de quantidade (+1/+2/+5/+10).
            const servicos = (await Servicos.list() ?? []).map(s => ({ ...s, type: 'service', measure: 'UN' }));
            lista_produtos.value = [...produtos, ...servicos];
        }

        const listClientes = async () => {
            lista_clientes.value = await Clientes.list();
        }

        const listPaymentMethods = async () => {
            lista_metodos_pagamento.value = await PaymentMethods.list() ?? [];
            selecionarMetodoPadrao();
        }

        function show_add_item(item) {
            openModal('modal_quant_item');
            setItem(item);
            if (item.measure == 'LT' || item.measure == 'KG') {
                zeros = 2;
            } else {
                zeros = 0;
            }
        }

        function show_finalizar() {
            if (dados.total > 0) {
                openModal('modal_finalizar');
            }
        }

        function show_pagamentodeconta() {
            openModal('modal_pagamentoconta');
        }

        // ----- Orçamento -----

        const orcamentoDescricao = ref('');
        const salvandoOrcamento = ref(false);
        const lista_orcamentos = ref([]);
        // Id do orçamento recém-emitido nesta sessão de PDV — destaca a
        // linha dele na lista (ver salvarOrcamento/show_orcamentos).
        const orcamentoEmitidoId = ref(null);
        // Resultado do agendamento opcional feito junto do orçamento (ver
        // toggleAgendarVisita/salvarOrcamento): { ok: true, when } ou
        // { ok: false, message }, ou null quando nada foi agendado.
        const orcamentoAgendamentoInfo = ref(null);

        // "Agendar visita" — opcional, só existe quando o carrinho do
        // orçamento tem algum serviço (agendamento sempre precisa de um
        // serviço, ver AppointmentController).
        const agendarVisita = ref(false);
        const agendamentoServicoId = ref(null);
        const agendamentoData = ref('');
        const agendamentoDuracao = ref(60);

        const servicosNoCarrinho = computed(() => {
            const vistos = new Set();
            return dados.lista
                .filter(item => item.type === 'service' && !vistos.has(item.id) && vistos.add(item.id))
                .map(item => ({ id: item.id, name: item.name }));
        });

        function toggleAgendarVisita() {
            if (!agendarVisita.value) return;
            agendamentoServicoId.value = servicosNoCarrinho.value[0]?.id ?? null;
            atualizarDuracaoAgendamento();
        }

        function atualizarDuracaoAgendamento() {
            const servico = lista_produtos.value.find(p => p.type === 'service' && p.id === agendamentoServicoId.value);
            agendamentoDuracao.value = servico?.duration_minutes ?? 60;
        }

        function orcamentoStatusLabel(status) {
            return { pending: 'Pendente', approved: 'Aprovado', rejected: 'Recusado' }[status] ?? status;
        }

        function orcamentoStatusBadge(status) {
            return {
                pending: 'text-bg-warning',
                approved: 'text-bg-success',
                rejected: 'text-bg-danger',
            }[status] ?? 'text-bg-secondary';
        }

        function show_orcamento() {
            orcamentoDescricao.value = '';
            agendarVisita.value = false;
            agendamentoServicoId.value = null;
            agendamentoData.value = '';
            agendamentoDuracao.value = 60;
            openModal('modal_orcamento');
        }

        async function salvarOrcamento() {
            salvandoOrcamento.value = true;
            const criado = await Orcamentos.create({ ...dados, description: orcamentoDescricao.value });
            salvandoOrcamento.value = false;

            if (!criado) {
                msn_feedback.value = Orcamentos.lastErrorMessage.value || 'Erro ao emitir orçamento!';
                openModal('modal_feedback');
                return;
            }

            orcamentoAgendamentoInfo.value = null;
            if (agendarVisita.value && agendamentoServicoId.value && agendamentoData.value) {
                const agendamentoCriado = await Agendamentos.create({
                    budget_id: criado.id,
                    service_id: agendamentoServicoId.value,
                    customer_id: dados.cliete !== 'avulso' ? dados.cliete.id : null,
                    scheduled_at: agendamentoData.value,
                    duration_minutes: agendamentoDuracao.value,
                });
                orcamentoAgendamentoInfo.value = agendamentoCriado
                    ? { ok: true, when: agendamentoCriado.scheduled_at }
                    : { ok: false, message: Agendamentos.lastErrorMessage.value || 'Orçamento emitido, mas não foi possível agendar a visita.' };
            }

            closeModal();
            limpar_lista_compras();
            // Em vez do feedback genérico, mostra a lista de orçamentos
            // (últimos 7 dias) já com o recém-criado destacado no topo —
            // é ali que o operador vê os detalhes e pode imprimir.
            orcamentoEmitidoId.value = criado.id;
            await listOrcamentos();
            openModal('modal_orcamentos');
        }

        async function listOrcamentos() {
            const resultado = await Orcamentos.list();
            lista_orcamentos.value = resultado?.data ?? [];
        }

        function show_orcamentos() {
            orcamentoEmitidoId.value = null;
            orcamentoAgendamentoInfo.value = null;
            listOrcamentos();
            openModal('modal_orcamentos');
        }

        // ----- Converter orçamento em venda (reaproveita a tela de
        // finalizar venda: forma de pagamento, troco, recibo) -----

        // Id do orçamento sendo convertido — enquanto não-nulo, o modal
        // "Finalizar venda" (dados/pdv-cart) muda de comportamento (ver
        // finalizarOuConverter) e o cliente vira somente leitura.
        const convertendoOrcamentoId = ref(null);
        // Snapshot do carrinho de verdade do operador, restaurado quando a
        // conversão termina (com sucesso ou cancelada) — `dados` é
        // compartilhado com o carrinho principal, então convertendo um
        // orçamento não pode fazer o operador perder uma venda em
        // andamento.
        let carrinhoAntesDaConversao = null;

        function restaurarCarrinhoAposConversao() {
            if (carrinhoAntesDaConversao) {
                dados.lista = carrinhoAntesDaConversao.lista;
                dados.total = carrinhoAntesDaConversao.total;
                dados.cliete = carrinhoAntesDaConversao.cliete;
                dados.payment_method_id = carrinhoAntesDaConversao.payment_method_id;
                dados.pagamento = carrinhoAntesDaConversao.pagamento;
                carrinhoAntesDaConversao = null;
            }
            convertendoOrcamentoId.value = null;
        }

        function abrirConversaoOrcamento(orc) {
            carrinhoAntesDaConversao = {
                lista: dados.lista, total: dados.total, cliete: dados.cliete,
                payment_method_id: dados.payment_method_id, pagamento: dados.pagamento,
            };

            // Cliente completo (com `onaccount`) pra forma de pagamento
            // fiado aparecer certo — o que o orçamento guarda é só id+nome.
            const clienteCompleto = orc.customer_id ? lista_clientes.value.find(c => c.id === orc.customer_id) : null;

            dados.lista = [
                ...(orc.products ?? []).map(p => ({
                    id: p.product_id, type: 'product', name: p.product?.name, price: p.price_uni,
                    buy: p.product?.buy, quant: p.amount, total: p.price_total, measure: p.product?.measure ?? 'UN',
                })),
                ...(orc.services ?? []).map(s => ({
                    id: s.service_id, type: 'service', name: s.service?.name, price: s.price_uni,
                    buy: 0, quant: s.amount, total: s.price_total, measure: 'UN',
                })),
            ];
            dados.total = orc.total;
            dados.cliete = clienteCompleto ?? (orc.customer_id ? { id: orc.customer_id, name: orc.customer?.name, onaccount: 'not' } : 'avulso');
            dados.payment_method_id = null;
            selecionarMetodoPadrao();
            trocovalue.value = 0;
            trocovalueCliente.value = 0;

            convertendoOrcamentoId.value = orc.id;

            document.getElementById('modal_finalizar').addEventListener('hidden.bs.modal', restaurarCarrinhoAposConversao, { once: true });
            openModal('modal_finalizar');
        }

        function finalizarOuConverter() {
            if (convertendoOrcamentoId.value) {
                confirmarConversaoOrcamento();
            } else {
                finalizarvenda();
            }
        }

        async function confirmarConversaoOrcamento() {
            if (!dados.payment_method_id) return;

            const venda = await Orcamentos.convert(convertendoOrcamentoId.value, dados.payment_method_id);
            if (!venda) {
                // Deixa o modal aberto — o operador pode trocar a forma de
                // pagamento e tentar de novo, sem perder o que já escolheu.
                msn_feedback.value = Orcamentos.lastErrorMessage.value || 'Erro ao converter orçamento em venda!';
                openModal('modal_feedback');
                return;
            }

            // Reaproveita o motor de recibo de venda normal — `dados` ainda
            // tem os itens/cliente/pagamento do orçamento neste momento
            // (restaurarCarrinhoAposConversao só roda depois do modal fechar).
            montarRecibo(venda);
            closeModal();
            msn_feedback.value = 'Orçamento convertido em venda com sucesso!';
            openModal('modal_feedback');
            listOrcamentos();
            listProducts();
        }

        function add_item(item) {
            if(item.quant <= 0) {return}
            // Produto e serviço podem ter o mesmo id numérico (tabelas
            // diferentes) — o par (id, type) que identifica a linha do
            // carrinho, senão adicionar um serviço podia somar na
            // quantidade de um produto de id igual (ou vice-versa).
            const tipo = item.type ?? 'product';
            const existingItem = dados.lista.find(product => product.id === item.id && (product.type ?? 'product') === tipo);
            if (existingItem) {
                existingItem.quant = (Number(existingItem.quant) + Number(item.quant)).toFixed(zeros);
                existingItem.total = (existingItem.quant * existingItem.price);
            } else {
                const add = {
                    id: item.id,
                    type: tipo,
                    name: item.name,
                    price: item.price,
                    buy: item.buy,
                    code: item.code,
                    quant: Number(item.quant).toFixed(zeros),
                    total: (item.quant * item.price),
                    measure: item.measure
                }
                dados.lista.push(add)
                dados.lista.reverse();
            }
            closeModal();
            limparItem();
            calc_value();
        }

        function limpar_lista_compras() {
            dados.cliete = "avulso";
            dados.total = 0;
            dados.lista = [];
            dados.pagamento = "cash"
            dados.valuepayment = ''
            dados.description = ''
            // Sem isso, um troco calculado numa venda em dinheiro ficava
            // "preso" e podia aparecer errado no recibo da próxima venda.
            trocovalue.value = 0;
            trocovalueCliente.value = 0;
            selecionarMetodoPadrao();
        }

        function addQuant(quant) {
            item.quant = (Number(item.quant) + Number(quant)).toFixed(zeros);
        }

        function calc_value() {
            dados.total = 0;
            dados.lista.forEach(item => {
                dados.total += item.total;
            });
        }

        function formatarDataRecibo(data) {
            return data ? new Date(data).toLocaleString('pt-BR') : '';
        }

        // Snapshot dos dados da venda (produtos, total, pagamento, troco)
        // pro recibo — precisa rodar antes de limpar_lista_compras() zerar
        // `dados`.
        function montarRecibo(vendaCriada) {
            reciboOrcamento.value = null;
            const metodo = lista_metodos_pagamento.value.find(m => m.id === dados.payment_method_id);
            reciboVenda.value = {
                id: vendaCriada.id,
                date: vendaCriada.date,
                business: name_business,
                operator: auth.operator,
                cliente: dados.cliete !== 'avulso' ? dados.cliete.name : null,
                itens: dados.lista.map(item => ({
                    name: item.name,
                    quant: item.quant,
                    measure: item.measure,
                    price: item.price,
                    total: item.total,
                })),
                total: dados.total,
                pagamentoNome: metodo?.name ?? '-',
                troco: dados.pagamento === 'cash' && trocovalue.value > 0 ? trocovalue.value : null,
            };
        }

        function imprimirRecibo() {
            window.print();
        }

        function abrirConfigImpressao() {
            printForm.width = PrintSettings.width;
            printForm.fontSize = PrintSettings.fontSize;
            printForm.margin = PrintSettings.margin;
            openModal('modal_config_impressao');
        }

        function salvarConfigImpressao() {
            PrintSettings.update(printForm);
            closeModal();
        }

        // Snapshot de um orçamento (o recém-emitido ou qualquer um da
        // lista) pro recibo de impressão — ver #orcamento-impressao.
        function montarReciboOrcamento(orc) {
            reciboVenda.value = null;
            reciboOrcamento.value = {
                id: orc.id,
                date: orc.created_at,
                business: name_business,
                operator: orc.operator?.name ?? auth.operator,
                cliente: orc.customer?.name ?? null,
                status: orcamentoStatusLabel(orc.status),
                validoAte: orc.valid_until,
                descricao: orc.description,
                itens: [
                    ...(orc.products ?? []).map(p => ({
                        name: p.product?.name, quant: p.amount, price: p.price_uni, total: p.price_total, servico: false,
                    })),
                    ...(orc.services ?? []).map(s => ({
                        name: s.service?.name, quant: s.amount, price: s.price_uni, total: s.price_total, servico: true,
                    })),
                ],
                total: orc.total,
            };
        }

        function imprimirOrcamento(orc) {
            montarReciboOrcamento(orc);
            // O bloco de impressão só existe no DOM depois do v-if virar
            // true — sem esperar o próximo tick, window.print() podia
            // disparar antes do Vue renderizar o conteúdo novo.
            nextTick(() => window.print());
        }

        const finalizarvenda = async () => {
            if (!auth.checkAuth('operator')) {
                logout();
                return;
            }
            const vendaCriada = await Vendas.createItem(dados);
            if (vendaCriada) {
                montarRecibo(vendaCriada);
                closeModal();
                limpar_lista_compras();
                msn_feedback.value = 'Venda finalizada com sucesso!';
                openModal('modal_feedback');
            } else {
                reciboVenda.value = null;
                reciboOrcamento.value = null;
                // Mostra o motivo de verdade (ex.: "Estoque insuficiente: ...")
                // quando a API manda um; sem isso a mensagem genérica escondia
                // por que a venda foi recusada.
                msn_feedback.value = Vendas.lastErrorMessage.value || 'Erro ao finalizar venda!';
                openModal('modal_feedback');
                console.log('Erro ao finalizar venda');
            }
        }

        const enviarpagamento = async () => {
            reciboVenda.value = null;
            reciboOrcamento.value = null;
            if (await Clientes.AccontPayment(dados.cliete.id, dados.valuepayment, dados.payment_method_id, dados.description)) {
                closeModal();
                limpar_lista_compras();
                msn_feedback.value = 'Pagamento registrado com sucesso!';
                openModal('modal_feedback');
            } else {
                msn_feedback.value = 'Erro ao registrar pagamento!';
            }
            limparClientePagConta()
        }

        function show_fechar_caixa() {
            openModal('modal_fechar_caixa');
        }

        const enviar_fechamento = async () => {
            if (await Cashier.close(caixa_dados)) {
                closeModal();
                logout();
            } else {
                reciboVenda.value = null;
                reciboOrcamento.value = null;
                msn_feedback.value = 'Erro ao fechar caixa!';
                closeModal();
                openModal('modal_feedback');
            }
        }

        function logout() {
            auth.setToken('');
            auth.setUser('');
            auth.setOperator('');
            auth.setEdit('');
            Infos.setBusiness('');
            router.push({name: 'home'});
        }

        onMounted(function () {
            //Função: leitor de codigos
            window.addEventListener('keypress', handleKeypress);

            //Função: Atalhos
            window.addEventListener('keydown', handleKeydown)

            listProducts();
            listClientes();
            listPaymentMethods();
        });

        onBeforeUnmount(() => {
            window.removeEventListener('keypress', handleKeypress);
            window.removeEventListener('keydown', handleKeydown)
        });

        return {
            auth,
            enviarpagamento,
            filtrarSugestoes,
            filtrarSugestoesProdutos,
            filtrarSugestoesPagConta,
            sugestoesprodutos,
            sugestoesPagConta,
            selecionar,
            selecionarPagConta,
            selecionarproduto,
            buscacliente,
            buscaclientePagConta,
            buscaprodutos,
            limparCliente,
            limparProduto,
            remove_item,
            logout,
            msn_feedback,
            finalizarvenda,
            lista_clientes,
            show_finalizar,
            show_editar_item,
            addQuant,
            name_business,
            lista_produtos,
            add_item,
            edit_item,
            dados,
            limpar_lista_compras,
            limparClientePagConta,
            item,
            show_add_item,
            sugestoes,
            onaccontvalue,
            getAccontValue,
            trocovalue,
            calcularTroco,
            trocovalueCliente,
            caixa_dados,
            show_fechar_caixa,
            enviar_fechamento,
            enviar_gerente_pass,
            lista_metodos_pagamento,
            iconeMetodo,
            reciboVenda,
            formatarDataRecibo,
            imprimirRecibo,
            novoCliente,
            salvandoCliente,
            abrirNovoCliente,
            salvarNovoCliente,
            orcamentoDescricao,
            salvandoOrcamento,
            lista_orcamentos,
            orcamentoEmitidoId,
            orcamentoAgendamentoInfo,
            agendarVisita,
            agendamentoServicoId,
            agendamentoData,
            agendamentoDuracao,
            servicosNoCarrinho,
            toggleAgendarVisita,
            atualizarDuracaoAgendamento,
            orcamentoStatusLabel,
            orcamentoStatusBadge,
            show_orcamento,
            show_orcamentos,
            salvarOrcamento,
            convertendoOrcamentoId,
            abrirConversaoOrcamento,
            finalizarOuConverter,
            reciboOrcamento,
            imprimirOrcamento,
            printForm,
            reciboImpressaoStyle,
            abrirConfigImpressao,
            salvarConfigImpressao,
        }
    }
}
</script>

<style scoped>
    .pdv-shell {
        display: flex;
        min-height: 100vh;
        max-height: 100vh;
        gap: 0.75rem;
        padding: 0.75rem;
    }

    .pdv-catalog,
    .pdv-cart {
        background: var(--panel-bg);
        border-radius: var(--radius-lg);
        box-shadow: var(--shadow-sm);
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .pdv-catalog {
        flex: 1 1 66%;
    }

    .pdv-cart {
        flex: 1 1 34%;
        min-width: 320px;
    }

    .pdv-panel-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.75rem;
        padding: 0.9rem 1.1rem;
        background: linear-gradient(135deg, var(--header-bg) 0%, var(--header-bg-soft) 100%);
        color: #fff;
        flex-shrink: 0;
    }

    .pdv-panel-header__title {
        display: flex;
        align-items: center;
        gap: 0.6rem;
        min-width: 0;
    }

    .pdv-panel-header__title i {
        font-size: 1.25rem;
        opacity: 0.85;
    }

    .pdv-panel-header__title h1 {
        font-size: 1.15rem;
        font-weight: 600;
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .pdv-search {
        display: flex;
        gap: 0.6rem;
        padding: 0.85rem 1.1rem 0.5rem;
        flex-shrink: 0;
    }

    .pdv-product-grid {
        flex: 1;
        overflow-y: auto;
        padding: 0.75rem 1.1rem 1.1rem;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
        gap: 0.65rem;
        align-content: start;
    }

    .product-tile {
        border: 1px solid var(--border-color);
        border-radius: var(--radius);
        padding: 0.9rem 1rem;
        cursor: pointer;
        transition: transform 0.12s ease, box-shadow 0.12s ease, border-color 0.12s ease;
        background: var(--panel-bg);
    }

    .product-tile:hover {
        box-shadow: var(--shadow-md);
        border-color: var(--brand);
        transform: translateY(-2px);
    }

    .product-tile__name {
        font-weight: 600;
        color: var(--text-strong);
        margin-bottom: 0.6rem;
        line-height: 1.25;
        min-height: 2.4em;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .product-tile__meta {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 0.5rem;
    }

    .product-tile__code {
        font-size: 0.75rem;
        color: var(--text-muted);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .product-tile__price {
        font-weight: 700;
        color: var(--brand);
        white-space: nowrap;
    }

    .pdv-cart-list {
        flex: 1;
        overflow-y: auto;
    }

    .pdv-cart-table {
        font-size: 0.85rem;
        margin-bottom: 0;
    }

    .pdv-cart-table thead th {
        position: sticky;
        top: 0;
        background: var(--panel-bg);
        border-bottom: 1px solid var(--border-color);
        color: var(--text-muted);
        font-size: 0.7rem;
        text-transform: uppercase;
        letter-spacing: 0.03em;
        font-weight: 600;
        padding: 0.6rem 0.75rem;
    }

    .pdv-cart-table tbody td {
        padding: 0.6rem 0.75rem;
        vertical-align: middle;
        border-bottom: 1px solid var(--border-color);
    }

    .pdv-cart-table tbody tr:hover {
        background: var(--pdv-bg);
    }

    .pdv-cart-empty {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: var(--text-muted);
        padding: 2rem;
        text-align: center;
    }

    .pdv-cart-empty i {
        font-size: 2.5rem;
        margin-bottom: 0.5rem;
        opacity: 0.5;
    }

    .pdv-cart-empty span {
        font-size: 0.85rem;
    }

    .pdv-cart-total {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        padding: 0.9rem 1.1rem;
        border-top: 1px solid var(--border-color);
        flex-shrink: 0;
    }

    .pdv-cart-total span {
        color: var(--text-muted);
        font-size: 0.9rem;
    }

    .pdv-cart-total strong {
        font-size: 1.5rem;
        color: var(--text-strong);
    }

    .pdv-cart-actions {
        display: grid;
        grid-template-columns: 1fr 2fr;
        gap: 0.6rem;
        padding: 0 1.1rem 1.1rem;
        flex-shrink: 0;
    }

    .input-icon-group {
        position: relative;
    }

    .input-icon-group i {
        position: absolute;
        top: 50%;
        left: 0.9rem;
        transform: translateY(-50%);
        color: var(--text-muted);
        pointer-events: none;
    }

    .input-icon-group .form-control {
        padding-left: 2.4rem;
    }

    .input-icon-group .form-control:focus {
        border-color: var(--brand);
        box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
    }

    .pdv-suggestions {
        margin-top: 0.4rem;
        border: 1px solid var(--border-color);
        border-radius: var(--radius-sm);
        max-height: 220px;
        overflow-y: auto;
    }

    .pdv-suggestions__item {
        padding: 0.6rem 0.9rem;
        cursor: pointer;
        border-bottom: 1px solid var(--border-color);
    }

    .pdv-suggestions__item:last-child {
        border-bottom: none;
    }

    .pdv-suggestions__item:hover {
        background: var(--pdv-bg);
    }

    .pdv-total-highlight {
        font-size: 2rem;
        font-weight: 700;
        color: var(--brand);
        margin-bottom: 1rem;
    }

    .pdv-payment-methods .btn {
        border-radius: 999px;
    }

    .pdv-troco {
        background: var(--pdv-bg);
        border-radius: var(--radius);
        padding: 0.9rem;
    }

    .quant-btn {
        font-weight: 700;
    }

    @media (max-width: 900px) {
        .pdv-shell {
            flex-direction: column;
            max-height: none;
        }

        .pdv-cart {
            min-width: 0;
        }
    }
</style>

<!--
  Bloco de impressão não-escopado de propósito: a regra "esconde tudo
  menos o recibo" precisa alcançar o <body> do documento, que fica fora
  do template deste componente e nunca receberia o atributo de escopo
  do Vue.
-->
<style>
    #recibo-impressao,
    #orcamento-impressao {
        display: none;
    }

    @media print {
        body * {
            visibility: hidden;
        }

        #recibo-impressao,
        #recibo-impressao *,
        #orcamento-impressao,
        #orcamento-impressao * {
            visibility: visible;
        }

        #recibo-impressao,
        #orcamento-impressao {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: var(--recibo-largura, 80mm);
        }
    }

    #recibo-impressao .recibo,
    #orcamento-impressao .recibo {
        font-family: 'Courier New', Courier, monospace;
        font-size: var(--recibo-fonte, 12px);
        line-height: 1.4;
        color: #000;
        padding: var(--recibo-margem, 4mm);
    }

    #recibo-impressao .recibo__center,
    #orcamento-impressao .recibo__center {
        text-align: center;
    }

    #recibo-impressao .recibo__linha-tracejada,
    #orcamento-impressao .recibo__linha-tracejada {
        border-top: 1px dashed #000;
        margin: 6px 0;
    }

    #recibo-impressao .recibo__item,
    #orcamento-impressao .recibo__item {
        margin-bottom: 4px;
    }

    #recibo-impressao .recibo__linha,
    #orcamento-impressao .recibo__linha {
        display: flex;
        justify-content: space-between;
        gap: 8px;
    }

    #recibo-impressao .recibo__total,
    #orcamento-impressao .recibo__total {
        font-weight: bold;
        font-size: calc(var(--recibo-fonte, 12px) + 2px);
    }

    #recibo-impressao .recibo__rodape,
    #orcamento-impressao .recibo__rodape {
        font-size: calc(var(--recibo-fonte, 12px) - 2px);
        margin-top: 6px;
    }
</style>
